module.exports = __webpack_public_path__ + "static/media/onboarding-logo.c8e8b263.svg";